import { AccountServicePath, USERS_INFO } from "utils/constants";

export const resources = {
  isMenu: false,
  //   icon: <SpecialityIcon />,
  name: AccountServicePath + USERS_INFO,
  //   title: "Специалности",
  //   list: <ListSpecialities />,
  //   create: <CreateSpecialities />,
  //   createPermission: permissions.canCreateSpecialities,
  //   edit: <EditSpecialities />,
  //   editPermission: permissions.canUpdateSpecialities,
  //   show: <ShowSpecialities />,
  //   showPermission: permissions.canPreviewSpecialities,
  //   permission: permissions.canPreviewSpecialities,
};
